document.addEventListener('DOMContentLoaded', function() {
  const chatToggle = document.getElementById('chat-toggle');
  if (chatToggle) {
    const toggleBtn = document.getElementById('chat-toggle');
    const container = document.getElementById('chat-container');
    const body = document.getElementById('chat-body');
    const form = document.getElementById('chat-form');
    const input = document.getElementById('chat-input');

    const config = {
      apiKey: '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',
      voiceId: '21m00Tcm4TlvDq8ikWAM'
    };

    function appendMessage(sender, text) {
      const wrap = document.createElement('div');
      wrap.className = `msg ${sender}`;
      const span = document.createElement('span');
      span.className = 'text';
      span.textContent = text;
      wrap.appendChild(span);
      body.appendChild(wrap);
      body.scrollTop = body.scrollHeight;
    }

    async function queryChatGPT(msg) {
      const payload = {
        model: 'gpt-4o-mini',
        messages: [{ role: 'user', content: msg }],
        max_tokens: 200,
        temperature: 0.7
      };

      const res = await fetch('https://api.openai.com/v1/chat/completions', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${config.apiKey}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!res.ok) throw new Error('API error');
      const data = await res.json();
      return data.choices[0].message.content.trim();
    }

    function toggleChat() {
      const open = container.hasAttribute('hidden');
      if (open) {
        container.removeAttribute('hidden');
        toggleBtn.querySelector('.open').style.display = 'none';
        toggleBtn.querySelector('.close').style.display = 'block';
        input.focus();
      } else {
        container.setAttribute('hidden', '');
        toggleBtn.querySelector('.open').style.display = 'block';
        toggleBtn.querySelector('.close').style.display = 'none';
      }
    }

    toggleBtn.addEventListener('click', toggleChat);

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const msg = input.value.trim();
      if (!msg) return;
      appendMessage('user', msg);
      input.value = '';
      try {
        appendMessage('bot', '...');
        const reply = await queryChatGPT(msg);
        body.lastElementChild.remove();
        appendMessage('bot', reply);
      } catch (err) {
        body.lastElementChild.remove();
        appendMessage('bot', 'Sorry, something went wrong.');
      }
    });
  }
}); // <--- Add this! closes both if and DOMContentLoaded